import { Badge } from "react-bootstrap";
import { getFormattedTimeRemaining } from "../../utils/timeUtils.js";
import TimeBadge from "../TimeBadge.jsx";
import DepartureStatusIcon from "./DepartureStatusIcon.jsx";

/**
 * DepartureTimeBadge - Display single arrival time
 */
function DepartureTimeBadge({ update, scheduledTime }) {
  if (scheduledTime) {
    return (
      <Badge className="arrival scheduled">
        <DepartureStatusIcon status="scheduled" />
        <TimeBadge value={scheduledTime} />
        <span className="minutes">{getFormattedTimeRemaining(scheduledTime)}</span>
      </Badge>
    );
  }

  const time = update.time_value;
  const delay = update.delay_value;
  if (!time || time <= 0) return null;

  const status = delay < -120 ? "early" : delay > 120 ? "delayed" : "on-time";

  return (
    <Badge className={`arrival ${status}`}>
      <DepartureStatusIcon status={status} />
      <TimeBadge value={time} />
      <span className="minutes">{getFormattedTimeRemaining(time)}</span>
    </Badge>
  );
}

export default DepartureTimeBadge;
